<template>
  <section class="seminarCassette">
    <div class="seminarCassette_body">
      <h3 v-if="heading">{{ heading }}</h3>
      <slot />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SeminarCassette',

  props: {
    heading: String
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.seminarCassette {
  padding: 20px 18px;
  border: 1px solid var.$color-border-gray;
  border-radius: 5px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08);

  & + & {
    margin-top: 16px;
  }
}

.seminarCassette_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.seminarCassette_category {
  font-weight: 900;
  font-size: 1.2rem;
  color: var.$color-main-text;
  letter-spacing: normal;

  &[data-category='jizen'] {
    &::before {
      display: inline-block;
      content: '';
      width: 11px;
      height: 18px;
      background: url('~@/assets/icon/mobile.svg') no-repeat;
      background-size: 100% 100%;
      vertical-align: -3px;
      margin-right: 9px;
    }
  }

  &[data-category='friends'] {
    &::before {
      display: inline-block;
      content: '';
      width: 26px;
      height: 16px;
      background: url('~@/assets/icon/friends.svg') no-repeat;
      background-size: 100% 100%;
      vertical-align: -3px;
      margin-right: 9px;
    }
  }
}

::v-deep(.seminarCassette_body) {
  line-height: 1.57;
  white-space: pre-wrap;

  h3 {
    font-size: 1.8rem;
    line-height: 1.5;
    font-weight: 500;
  }

  h4 {
    margin-top: 30px;
    margin-bottom: 15px;
    padding-bottom: 3px;
    padding-left: 10px;
    border-left: 4px solid var.$color-main;
    font-size: 1.8rem;
    font-weight: 500;
    line-height: 1.2;
  }

  p {
    margin-top: 12px;
  }

  dt {
    margin-top: 16px;
    font-weight: 500;
  }

  dd {
    margin-top: 5px;
  }

  .note {
    font-size: 1.2rem;
    text-indent: -1em;
    margin-left: 1em;

    &::before {
      content: '※';
    }
  }

  a {
    color: var.$color-main-text;
  }
}
</style>
